import React from 'react';
import {ServicesList, type ServiceListItem} from 'features/service';
import {Section} from '.';

export type ServiceItem = ServiceListItem;

interface ServicesSectionProps {
	services: ServiceItem[];
}

export function ServicesSection({services}: ServicesSectionProps): React.ReactElement {
	return (
		<Section title="Услуги" count={services.length}>
			<ServicesList items={services} />
		</Section>
	);
}
